import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersService } from '@services/private/users.service';
import { RolesSI, UsersSI } from '@views/interfaces/services/users.interface';

@Component({
  selector: 'app-update-user',
  templateUrl: './update-user.component.html',
  styleUrls: ['./update-user.component.scss'],
})
export class UpdateUserComponent implements OnInit, OnChanges {
  @Input() user: UsersSI;
  public updateUserForm: FormGroup;
  @Input() roles: RolesSI[];
  @Output() newItemEvent = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private usersService: UsersService
  ) {}

  public height: number = window.innerHeight;
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.height = window.innerHeight;
  }

  ngOnInit(): void {
    this.createForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.user && changes.user.currentValue !== changes.user.previousValue) {
      this.setValues(changes.user.currentValue);
    }
  }

  createForm() {
    this.updateUserForm = this.formBuilder.group({
      rut: [''],
      firstName: [''],
      secondName: ['', []],
      fatherLastname: [''],
      motherLastname: [''],
      email: [''],
      role: ['', [Validators.required]],
    });
  }

  setValues(user: UsersSI) {
    if (user) {
      this.updateUserForm.get('rut').setValue(this.user.rut);
      this.updateUserForm.get('firstName').setValue(this.user.firstName);
      this.updateUserForm.get('secondName').setValue(this.user.secondName);
      this.updateUserForm
        .get('fatherLastname')
        .setValue(this.user.fatherLastname);
      this.updateUserForm
        .get('motherLastname')
        .setValue(this.user.motherLastname);
      this.updateUserForm.get('email').setValue(this.user.email);
      this.updateUserForm.get('role').setValue(this.user.role);
    }
  }

  async update() {
    if (this.updateUserForm.valid) {
      let role = this.roles.find((x) => x.key === this.updateUserForm.value.role);
      let body = {role: role}
      await this.usersService.update(this.user._id, body);
      this.newItemEvent.emit();
    }
  }
}
